<style scoped lang="scss">
  .wrap-user{
    width:1250px;
    margin:40px auto;
    display: flex;
    align-items: flex-start;
  }
  .side-menu{
    background: #F9F9F9;
    width:210px;
    margin-right: 40px;
    .title{
      margin:15px 20px 0;
      padding-bottom: 15px;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid #E4E6EA;
    }
    .el-menu{
      background: #F9F9F9;
      border-right: 0;
    }
    .el-menu-item.is-active{
      font-weight: bold;
      background: none;
    }
  }
  .main-con{
    flex:1;
  }
  @media screen and (max-width: 640px){
    .wrap-user{
      width: 92% !important;
      font-size: 14px!important;
      display: block!important;
      overflow: auto;
      overflow-x: hidden;
    }
    .wrap-user>>> .info-lists {
      display: block!important;
    }
    .wrap-user>>> .d-flex{
      display: block!important;
    }
    .wrap-user>>> .info-lists li{
      width: 100% !important;
      display: block!important;
    }
    .side-menu .title{
      padding-top: 20px;
    }
    .wrap-user .rules{
      width: 90% !important;
    }
    .side-menu{
      width: 100% !important;
    }

  }
</style>
<template>
  <div class="wrap wrap-user">
    <div class="side-menu">
      <div class="title">用户中心</div>
      <el-menu
        :default-active="$route.path"
        menu-trigger="click"
        :router="true">
        <el-menu-item index="/user">
          用户信息
        </el-menu-item>
        <el-menu-item index="/user/course" v-show="courseInfo.headMan && courseInfo.headMan.id === memberInfo.id">
          课题组信息
        </el-menu-item>
        <el-submenu index="3">
          <template slot="title">
            <span>我的订单/取样</span>
          </template>
          <el-menu-item index="/user/molecular">擎科科邦邦商城订单</el-menu-item>
          <el-menu-item index="/user/sanger">Sanger测序订单</el-menu-item>
          <el-menu-item index="/user/fastNGS">Fast NGS订单</el-menu-item>
          <el-menu-item index="/user/primer">引物合成订单</el-menu-item>
          <el-menu-item index="/user/gene">基因合成订单</el-menu-item>
          <el-menu-item index="/user/project">项目订单</el-menu-item>
          <el-menu-item index="/user/sanger_record">测序取样申请记录</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <span>积分兑换</span>
          </template>
          <el-menu-item index="/user/mall">积分商城</el-menu-item>
          <el-menu-item index="/user/integral_get">积分获取记录</el-menu-item>
          <el-menu-item index="/user/integral_exchange">积分兑换订单</el-menu-item>
        </el-submenu>
<!--        <el-submenu index="5">-->
<!--          <template slot="title">-->
<!--            <span>我的收藏</span>-->
<!--          </template>-->
<!--          <el-menu-item index="/user/Collection">商品收藏</el-menu-item>-->
<!--          &lt;!&ndash; <el-menu-item index="/user/arrivalNotice">到货通知</el-menu-item> &ndash;&gt;-->
<!--          <el-menu-item index="/user/comment">商品评论</el-menu-item>-->
<!--          <el-menu-item index="/user/consult">商品咨询</el-menu-item>-->
<!--        </el-submenu>-->
        <el-submenu index="6">
          <template slot="title">
            <span>我的优惠券</span>
          </template>
          <el-menu-item index="/user/My_Coupons">我的优惠券</el-menu-item>
          <el-menu-item index="/user/Binding_Coupons">绑定优惠券</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="main-con">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['reload'],
  data () {
    return {
      activeIndex: '/user',
      courseInfo: this.baseMethods.getLocalObj('courseInfo'),
      memberInfo: this.baseMethods.getLocalObj('memberInfo')
    }
  },
  methods:{
    getParameter(name){
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)","i");
      let r = location.search.substr(1).match(reg);
      if (r!=null) return (r[2]); return null;
    }
  },
  created() {
    this.reload();
    let games = this.getParameter("id"); //通过getParameter获取
    if(games){
      this.$router.push(`/user/molecular_details?id=${games}`)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/user/index.vue